<template>
    <div style="text-align: center; margin-top: 24px;">
        <div>
            <div style="font-size: 32px; font-weight: 700; line-height: 46px;">어떻게 불러드릴까요?</div>
            <div style="margin-top: 16px; display: flex; flex-direction: column; gap: 12px;">
                <div @click="selectExpertInfo('감독')" :style="{ backgroundColor: expertInfo === '감독' ? 'var(--color-main)' : '#fff' }" style="width: 254px; height: 56px; line-height: 56px; border-radius: 12px; background-color: #fff; margin: 0 auto; border: 1px solid #d9d9d9; font-size: 20px; font-weight: 700;">감독</div>
                <div @click="selectExpertInfo('코치')" :style="{ backgroundColor: expertInfo === '코치' ? 'var(--color-main)' : '#fff' }" style="width: 254px; height: 56px; line-height: 56px; border-radius: 12px; background-color: #fff; margin: 0 auto; border: 1px solid #d9d9d9; font-size: 20px; font-weight: 700;">코치</div>
                <div @click="selectExpertInfo('프로 선수')" :style="{ backgroundColor: expertInfo === '프로 선수' ? 'var(--color-main)' : '#fff' }" style="width: 254px; height: 56px; line-height: 56px; border-radius: 12px; background-color: #fff; margin: 0 auto; border: 1px solid #d9d9d9; font-size: 20px; font-weight: 700;">프로 선수</div>
                <div @click="selectExpertInfo('선수 출신')" :style="{ backgroundColor: expertInfo === '선수 출신' ? 'var(--color-main)' : '#fff' }" style="width: 254px; height: 56px; line-height: 56px; border-radius: 12px; background-color: #fff; margin: 0 auto; border: 1px solid #d9d9d9; font-size: 20px; font-weight: 700;">선수 출신</div>
                <div @click="selectExpertInfo('스카우트')" :style="{ backgroundColor: expertInfo === '스카우트' ? 'var(--color-main)' : '#fff' }" style="width: 254px; height: 56px; line-height: 56px; border-radius: 12px; background-color: #fff; margin: 0 auto; border: 1px solid #d9d9d9; font-size: 20px; font-weight: 700;">스카우트</div>
            </div>
        </div>
    </div>
</template>

<script>
// import { REGIST_STEP } from '@/Constants';

export default {
    name: 'SignupExpertInfo',
    props: {
        selectExpertInfo: {
            type: Function,
            default: () => { }
        },
        expertInfo: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: 'insert'
        },
        registInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
    created() {
        if (this.mode === 'update') {
            this.selectExpertInfo(this.registInfo.expertInfo)
        }
    }
}
</script>

<style scoped>
.common_input {
    width: 310px;
    height: 56px;
    outline: none;
    border-radius: 12px;
    border: none;
    padding: 0 12px;
}

.common_input::placeholder {
    font-size: 20px;
    font-weight: 500;
    color: #bbbbbb;
}
</style>